import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CpeDropdownService } from "../../cpes/cpe-dropdown.service";
import { DropdownShortcut } from "@nms-angular-toolkit/nms-dropdown";
import { Onu } from "@nms-ng1/features/gpon-onus/gpon-onus-models";
import { SvgHandlerService } from "@nms-ng2/app/shared/services/svg/svg-handler.service";

/**
 * Componente responsável por listar as possíveis ações para ONUs registradas via TR-069.
 */
@Component({
    selector: "tr069-actions",
    templateUrl: "./tr069-actions.component.html",
    styleUrls: ["./tr069-actions.component.scss"]
})
export class Tr069ActionsComponent implements OnInit {
    @Input() selectedOnus: Onu[] = [];
    @Output() onSelect: EventEmitter<void> = new EventEmitter<void>();

    shortcuts = []
    isHovered = []

    constructor(private readonly cpeDropdownService: CpeDropdownService,
        private readonly svgToImageUrlConverter: SvgHandlerService
    ) { }

    ngOnInit(): void {
        this.shortcuts = this.cpeDropdownService.getTR069Shortcuts(null) as Array<DropdownShortcut>;
    }

    /**
     * Verificar se o atalho é visível ou não. O valor default é true, caso não exista uma função de verificação de
     * visibilidade.
     */
    isVisible(shortcut) {
        return shortcut.isVisible ? shortcut.isVisible(this.selectedOnus) : true;
    }

    onShortcutClick(shortcut) {
        this.onSelect.emit();
        this.isHovered = [];
        shortcut.action(this.selectedOnus)
    }

    getSVGImageUrl(image) {
        return this.svgToImageUrlConverter.convertToBase64(image);
    }

    getShortcutIcon(shortcut, index) {
        return this.isHovered[index]
            ? this.svgToImageUrlConverter.convertToBase64(shortcut.customSvgIcon, "#fff")
            : this.svgToImageUrlConverter.convertToBase64(shortcut.customSvgIcon);
    }

}
